import React from 'react';
import { motion } from 'framer-motion';

import Head from 'u9/components/Head';

import {
  Wrapper,
  Title,
  Hero,
  Client,
  TechTagsWrapper,
  Label,
  TechTag,
  Description,
  Video,
  Image,
  ImageWrapper,
  Gallery,
} from './styled';

interface ProjectPageProps {
  slug: string;
  title: string;
  client: string;
  description: string;
  techTags: [
    {
      name: string;
      discipline: string;
    }
  ];
  poster: {
    url: string;
  };
  desktopImages: [
    {
      url: string;
    }
  ];
  mobileImages: [
    {
      url: string;
    }
  ];
  videos: [
    {
      url: string;
    }
  ];
}

const ProjectPage: React.FunctionComponent<ProjectPageProps> = ({
  title,
  client,
  description,
  poster,
  techTags,
  desktopImages,
  mobileImages,
  videos,
}) => {
  return (
    <>
      <Head
        image={poster}
        title={`Scott Ashmore - ${client} ${title}`}
        description=""
      />
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 50 }}
        transition={{ duration: 0.5, ease: 'easeOut' }}
      >
        <Wrapper>
          <Client>{client}</Client>
          <Title>{title}</Title>
          <Hero
            src={poster.url}
            alt={title}
            width={500}
            height={300}
            objectFit="cover"
            priority
          />
          {description && <Description>{description}</Description>}
          <TechTagsWrapper>
            <Label>- Tech used</Label>
            {techTags.map(tag => (
              <TechTag key={tag.name}>{tag.name}</TechTag>
            ))}
          </TechTagsWrapper>
          {videos && videos.length > 0 && (
            <Gallery>
              {videos.map(({ url }) => (
                <motion.li key={url}>
                  <Video src={url} controls autoplay />
                </motion.li>
              ))}
            </Gallery>
          )}
          {desktopImages && desktopImages.length > 0 && (
            <Gallery>
              {desktopImages.map(({ url }) => (
                <ImageWrapper key={url} type="desktop">
                  <Image
                    src={url}
                    alt={title}
                    layout="fill"
                    objectFit="cover"
                  />
                </ImageWrapper>
              ))}
            </Gallery>
          )}
          {mobileImages && mobileImages.length > 0 && (
            <Gallery>
              {mobileImages.map(({ url }) => (
                <ImageWrapper key={url} type="mobile">
                  <Image
                    src={url}
                    alt={title}
                    layout="fill"
                    objectFit="cover"
                  />
                </ImageWrapper>
              ))}
            </Gallery>
          )}
        </Wrapper>
      </motion.div>
    </>
  );
};

export default ProjectPage;
